import { IonicModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { DirectivesModule } from './../directives/directives.module';
import { EmptyStateComponent } from './empty-state/empty-state';
import { EtaWarningModalComponent } from './eta-warning-modal/eta-warning-modal';
import { OnTimePercentageModalComponent } from './on-time-percentage-modal/on-time-percentage-modal';
import { PipesModule } from '../pipes/pipes.module';
import { ProgressBarComponent } from './progress-bar/progress-bar';
import { SimpleMessageModalComponent } from './simple-message-modal/simple-message-modal';

@NgModule({
  declarations: [
    OnTimePercentageModalComponent,
    ProgressBarComponent,
    EmptyStateComponent,
    SimpleMessageModalComponent,
    EtaWarningModalComponent,
  ],
  imports: [IonicModule, DirectivesModule, PipesModule],
  exports: [
    OnTimePercentageModalComponent,
    ProgressBarComponent,
    EmptyStateComponent,
    SimpleMessageModalComponent,
    EtaWarningModalComponent,
  ],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts